export default __webpack_public_path__ + "static/background-19a27154fee50daf51b17b179fd01e92.jpg";